import { render } from "./PlateExpanded.vue?vue&type=template&id=0bcb8f62&scoped=true"
import script from "./PlateExpanded.vue?vue&type=script&lang=js"
export * from "./PlateExpanded.vue?vue&type=script&lang=js"

import "./PlateExpanded.vue?vue&type=style&index=0&id=0bcb8f62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bcb8f62"]])

export default __exports__